export const TOLGEE_KEYS = {
  title: {
    key: 'DesktopNotAllowedRouteModal-title',
    defaultValue: 'Tenha acesso a novos insights na palma da sua mão!',
  },
  description: {
    key: 'DesktopNotAllowedRouteModal-description',
    parameters: {
      strong: <strong></strong>,
    },
    defaultValue: `Esta é uma página exclusiva para uso em <strong>dispositivos móveis</strong>.
      Para acessá-la, entre a partir de um celular.`,
  },
  illustrationDescription: {
    key: 'DesktopNotAllowedRouteModal-illustrationDescription',
    defaultValue:
      'Três smartphones exibindo um aplicativo de análise de dados. O primeiro telefone mostra um gráfico de linhas comparando a participação semanal de diferentes marcas. O segundo exibe um gráfico de pizza com a divisão de atenção entre as marcas. O terceiro apresenta uma lista de insights e perguntas analíticas sobre o desempenho das marcas.',
  },
  or: {
    key: 'DesktopNotAllowedRouteModal-or',
    defaultValue: 'ou',
  },
  returnToInsights: {
    key: 'DesktopNotAllowedRouteModal-returnToInsights',
    defaultValue: 'Retornar à Winnin Intelligence',
  },
}
